declare const __LIBCREEP_ALGORITHM_VERSION__: string;
declare const __LIBCREEP_PACKAGE_VERSION__: string;

/** Version of the fingerprinting algorithm and canonical hash format. */
export const ALGORITHM_VERSION = __LIBCREEP_ALGORITHM_VERSION__;

/** Version of the installed libcreep package. */
export const LIBRARY_VERSION = __LIBCREEP_PACKAGE_VERSION__;
